import { WalletTransactionEnums } from "../enums/WalletTransactionEnums";

export function getReferenceName (referenceModelName: WalletTransactionEnums) {
    switch (referenceModelName) {
        case WalletTransactionEnums.ONE_MEAL_SERVICE:
            return "OneMealService";
        case WalletTransactionEnums.CHEF_FOR_PARTY_ORDER:
            return "ChefForParty";
        case WalletTransactionEnums.CHEF_FOR_PARTY:
            return "ChefForParty";    
        case WalletTransactionEnums.DISCOUNT_COUPON_ORDER:
            return "Combo";
        default:
            return 'PromotionalBalance';
    }
}